import cx from 'classnames';
import React from 'react';
/* Components */
export const ListItem = ({ children, className, separated, ...rest }) => (React.createElement("li", { className: cx({ 'tds-list-item--separated': separated }, className), ...rest }, children));
